module.exports = __webpack_public_path__ + "d92ac7f479ba4a9e48b3d7e16b5dea17.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/cats/inactive-icon-spa@2x.png
// module id = 1763
// module chunks = 0